export enum Country {
    TUNISIA = 'TUNISIA',
    LIBYA = 'LIBYA',
}

export const getCountryCode = () => {
    const country = Intl.DateTimeFormat().resolvedOptions().timeZone;
    switch (country) {
        case 'Africa/Tunis':
            return Country.TUNISIA;
        case 'Africa/Tripoli':
            return Country.LIBYA;
        default:
            return Country.TUNISIA;
    }
};